/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "Yes, delete" |
*
* @param {Context_Menu_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_confirm = /** @type {((inputs?: Context_Menu_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, supprimer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, elimina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, удалить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, eliminar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, हटा दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, apagar")
	return /** @type {LocalizedString} */ ("Yes, delete")
});